import React, { useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import { MRT_ColumnDef } from "material-react-table";
import FormBuilder from "../../../../../../shared/components/form-builder/form-builder";
import {
  ITCProduct,
  Option,
  transformShipmentDetails,
} from "../../../../tc-models/tc-req-dto/tc-certified-product-details.req_dto";
import { dtrackItService } from "../../../../tc-service/dtrackit.service";
import { TCAppConfig } from "../../../../../../shared/app-configs/tc-app-configs";
import { mapToIShipmentConsigneeDetails } from "../../../../tc-models/tc-req-dto/tc-shipments.req_dto";
import { useApi } from "../../../../../../shared/hooks/useApi";
import { useParams } from "react-router-dom";
import { useFormActions } from "../../../../../../shared/hooks/form-builder.hooks";
import useNotification from "../../../../../../shared/hooks/useNotification";
import { Utills } from "../../../../../../shared/app-configs/utilit";
import { useTransactionCertificateStore } from "../../../../../../store/transaction-certificates.store";
import { Box, Typography } from "@mui/material";
interface ProductInfoProps {
  productData: ITCProduct;
  setProductData: React.Dispatch<React.SetStateAction<ITCProduct>>;
  shipmentId: string;
  formRef: any;
}
const ProductInfo: React.FC<ProductInfoProps> = ({
  formRef,
  productData,
  setProductData,
  shipmentId,
}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [labelGrades, setLabelGrades] = useState([]);
  const [productCategory, setProductCategory] = useState([]);
  const [shipmenOptions, setShipmentOptions] = useState<Option[]>([]);
  const { executeGet } = useApi();
  const { TE_ID } = useParams();
  const [productDetails, setProductDetails] = useState([]);
  const {
    setProductCategoriesStore,
    setProductDetailCodeStore,
    getTCStandardGOTS,
  } = useTransactionCertificateStore();

  const { setDeleteSave } = useFormActions("certified-products");
  // const [productData, setProductData] = useState<ITCProduct>(productData);
  const loadFormData = async () => {
    try {
      const response = await executeGet(TCAppConfig.GET_SHIPMENTS_LIST, {
        tcId: TE_ID,
      });
      const result =
        response?.data.response?.map((detail: { tcShipmentNo?: string }) => ({
          value: detail.tcShipmentNo ?? "",
          label: detail.tcShipmentNo ?? "",
        })) || [];
      setShipmentOptions(result);
      if (result?.length === 1) {
        if (getTCStandardGOTS) {
          // alert( result?.reduce((r: any) => r).value  )
          productData.tcProductShipmentNo = result?.map((r: any) => r.value);
          // formRef.current.setFieldValue("tcProductShipmentNo", result);
        }
      }
    } catch (err) {
      console.error("Failed to fetch TC Base Details:", err);
    }
  };

  useEffect(() => {
    const getLabelGrades = async () => {
      try {
        const result: any = await dtrackItService.getStandradLabelGrade();
        // Utills.cl(`result ${JSON.stringify(result)}`)
        const lblGrades = result.data.map((t: any) => ({
          value: t.code_1,
          label: `${t.description_1} (${t.code_1})`,
        }));
        Utills.cl(`lblGrades ${JSON.stringify(lblGrades)}`);
        setLabelGrades(lblGrades);
        Utills.cl(`lblGrades ${lblGrades}`);
      } catch (err) {
        Utills.cl(`Error in Fetching Organic Farm Standard Code ${err}`);
      }
    };

    const getProductCategory = async () => {
      try {
        const result: any = await dtrackItService.getProductCategory();

        // Utills.cl(`result ${JSON.stringify(result)}`)

        const prdtCategory = result.data.map((t: any) => ({
          value: t.code_1,
          label: `${t.description_1} (${t.code_1})`,
        }));
        Utills.cl(`prdtCategory ${JSON.stringify(prdtCategory)}`);
        setProductCategory(prdtCategory);
        setProductCategoriesStore(prdtCategory);
      } catch (err) {
        Utills.cl(`Error in Fetching Organic Farm Standard Code ${err}`);
      }
    };

    const getProductDetails = async () => {
      try {
        const result: any = await dtrackItService.getProductDetailsCode();

        Utills.cl(`result getProductDetails ${JSON.stringify(result)}`);

        const prdtDetails = result.data.map((t: any) => ({
          value: t.code_1,
          label: `${t.description_1} (${t.code_1})`,
        }));
        Utills.cl(`prdtDetails ${JSON.stringify(prdtDetails)}`);
        setProductDetails(prdtDetails);
        setProductDetailCodeStore(prdtDetails);
      } catch (err) {
        Utills.cl(`Error in Fetching Organic Farm Standard Code ${err}`);
      }
    };

    TE_ID && loadFormData();

    getLabelGrades();
    getProductCategory();
    getProductDetails();
  }, []);

  // Second useEffect to detect added/removed values

  const toggleDrawer = () => {
    if (drawerOpen) resetForm();
    setDrawerOpen((prev) => !prev);
  };

  const resetForm = () => {
    setProductData(productData);
  };
  const onLabelGradeChange = (e: any) => {
    Utills.cl(`onLabelGradeChange ${e}`);
  };
  const productValidationSchema = Yup.object().shape({
    // Shipment and Product Information
    // associatedShipmentNo: Yup.string().nullable(),
    tcProductDetailCode: Yup.string().required("Product Details are required"),
    tcProductCategoryCode: Yup.string().required(
      "Product Category is required"
    ),

    tcProductNo: Yup.string()
      .required("Product No. is required")
      .max(40, "Maximum 40 Character is allowed"),

    tcNetShippingWeight: Yup.string()
      .test(
        "is-exactly-two-decimal-places",
        "Number must be a valid decimal number with up to 2 decimal places.",
        (value: string | undefined) => {
          if (!value) return true; // Allow empty values
          return /^(0|[0-9]\d*|0\.\d{1,2}|[0-9]\d*\.\d{1,2})$/.test(value);
        }
      )
      .when([], {
        is: () => !getTCStandardGOTS,
        then: Yup.string().required("Product Net Shipping Weight is required"),
      })
      .typeError("Product Net Shipping Weight must be a valid number"),

    tcProductSupplementaryWeight: Yup.string()
      .test(
        "is-exactly-two-decimal-places",
        "Number must be a valid decimal number with up to 2 decimal places.",
        (value: string | undefined) => {
          if (!value) return true;
          return /^(0|[0-9]\d*|0\.\d{1,2}|[0-9]\d*\.\d{1,2})$/.test(value);
        }
      )
      .when([], {
        is: () => !getTCStandardGOTS,
        then: Yup.string().required(
          "TC Product Supplementary Weight is required"
        ),
      })
      .typeError("Product Supplementary Weight must be a valid number")
      .test(
        "supplementary-less-than-net",
        "TC Product Supplementary Weight must be less than TC Product Net Shipping Weight",
        function (value: any) {
          const netWeight = parseFloat(this.parent.tcNetShippingWeight);
          const suppWeight = parseFloat(value);
          if (isNaN(netWeight) || isNaN(suppWeight)) return true;
          return suppWeight < netWeight;
        }
      ),

    tcProductOrderNo: Yup.array()
      .of(
        Yup.string()
          .required("Order No. is required")
          .matches(
            /^[^\s]+$/,
            "Order No. cannot have white spaces"
          )
      )
      .when([], {
        is: () => !getTCStandardGOTS, // Apply required validation only when GOTS is NOT present
        then: Yup.array()
          .min(1, "At least one Order No. is required")
          .required("Order No. is required"),
        otherwise: Yup.array().nullable(), // Allow empty when GOTS is present
      })
      .max(255, "Maximum 255 Characters are allowed"),

      tcProductArticleNo: Yup.string()
      .required("Article No. is required")
      .test('not-invalid-value', 'A valid product article No is required. "n/a, N/A, NULL, null, Not available" are not accepted', 
        function(value) {
          if (!value) return false; // Required will handle this
          const trimmedValue = value.trim().toLowerCase();
          const invalidValues = ['n/a', 'n\\a', 'null', 'not available', 'nil'];
          const isInvalid = invalidValues.some(invalid => trimmedValue === invalid);
          return !isInvalid; 
        })
      .max(2000, "Maximum 2000 Characters are allowed"),
    

    tcProductNumberOfUnits: Yup.string()
      .test(
        "is-exactly-two-decimal-places",
        "Number must be a valid decimal number with up to 2 decimal places.",
        (value: string | undefined) => {
          if (!value) return true;
          return /^(0|[0-9]\d*|0\.\d{1,2}|[0-9]\d*\.\d{1,2})$/.test(value);
        }
      )
      .when([], {
        is: () => !getTCStandardGOTS,
        then: Yup.string().required("TC Product Number of Units is required"),
      })
      .typeError("TC Product Number of Units must be a valid number"),

    tcProductUnitsMetric: Yup.string()
      .when([], {
        is: () => !getTCStandardGOTS,
        then: Yup.string().required("Units Metric is required"),
      })
      .max(40, "Maximum 40 Characters are allowed")
      .test(
        "no-numeric-values",
        "Units Metric must not contain Numbers/Special Characters",
        (value: any) => /^[A-Za-z\s]+$/.test(value)
      ),

    tcProductInfoAssociatedTc: Yup.string().nullable(),
    tcProductCategoryUserSpecificTerm: Yup.string()
      .nullable()
      .max(255, "Maximum 255 Characters is allowed"),
    tcProductDetailUserSpecificTerm: Yup.string()
      .nullable()
      .max(255, "Maximum 255 Characters is allowed"),
    tcProductProductionDate: Yup.string().nullable(),

    tcProductShipmentNo: Yup.string().when([], {
      is: () => !getTCStandardGOTS,
      then: Yup.string().required("Shipment No. is required"),
      otherwise: Yup.string().nullable(),
    }),
  });
  const formConfig = {
    pageName: "certified-products",
    subPageName: "tcProductInformation",
    initialValues: productData,
    validationSchema: productValidationSchema,
    sections: [
      {
        title: "Add Product",
        fields: [
          {
            label: "Select Shipment No.",
            name: "tcProductShipmentNo",
            type: "select",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: !getTCStandardGOTS ? true : false,
            value: productData.tcProductShipmentNo,
            events: {
              onChange: (
                updatedValue: any,
                values: any,
                setFieldValue: any,
                index: any
              ) => {},
            },
            props: {
              options: shipmenOptions, //shipmenOptions,
              placeholder: "Select Shipment No.",
            },
          },
          {
            label: "Product No.",
            name: "tcProductNo",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: true,
            value: productData.tcProductNo,
            props: {
              placeholder: "Enter Product No.",
            },
          },
          {
            label: "Product Category",
            name: "tcProductCategoryCode",
            type: "select",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: true,
            value: productData.tcProductCategoryCode,
            props: {
              enableSearch: true,
              options: productCategory,
              placeholder: "Select Product Category",
            },
          },
          {
            label: "Product Category User Specific Term",
            name: "tcProductCategoryUserSpecificTerm",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            value: productData.tcProductCategoryUserSpecificTerm,
            props: {
              placeholder: "Enter Product Category User Specific Term",
            },
          },
          {
            label: "Product Detail Code",
            name: "tcProductDetailCode",
            type: "select",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: true,
            value: productData.tcProductDetailCode,
            props: {
              enableSearch: true,
              options: productDetails,
              placeholder: "Select Product Detail Code",
            },
          },
          {
            label: "Product Details User Specific Term",
            name: "tcProductDetailUserSpecificTerm",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            value: productData.tcProductDetailUserSpecificTerm,
            props: {
              placeholder: "Enter Product Details User Specific Term",
            },
          },
          {
            label: "Production Date",
            name: "tcProductProductionDate",
            type: "date",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            value: productData.tcProductProductionDate,
            props: {
              placeholder: "Select Production Date",
            },
          },
          {
            label: "Net Shipping Weight (kg)",
            name: "tcNetShippingWeight",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: !getTCStandardGOTS ? true : false,
            value: productData.tcNetShippingWeight,
            props: {
              type: "number",
              placeholder: "Enter Net Shipping Weight",
            },
          },
          {
            label: "Supplementary Weight (kg)",
            name: "tcProductSupplementaryWeight",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: !getTCStandardGOTS ? true : false,
            value: productData.tcProductSupplementaryWeight,
            props: {
              type: "number",
              placeholder: "Enter Supplementary Weight",
            },
          },
          {
            label: "Order No.",
            name: "tcProductOrderNo",
            type: "chips",
            gridSize: { xs: 12, md: 12, lg: 12 },
            required: !getTCStandardGOTS ? true : false,
            value: productData.tcProductOrderNo,
            props: {
              placeholder: "Enter Product Order No.",
            },
          },
          // {
          //   label: 'Product Shipment No',
          //   name: 'tcProductShipmentNo',
          //   type: 'chips',
          //   gridSize: { xs: 12, md: 12, lg: 12 },
          //   required: false,
          //   value: productData.tcProductShipmentNo,
          //   props: {
          //     placeholder: 'Enter TC Product Shipment No.',
          //   },
          // },
          {
            label: "Article No.",
            name: "tcProductArticleNo",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: true,
            value: productData.tcProductArticleNo,
            props: {
              placeholder: "Enter Product Article No.",
            },
          },
          {
            label: "Number of Units",
            name: "tcProductNumberOfUnits",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: !getTCStandardGOTS ? true : false,
            value: productData.tcProductNumberOfUnits,
            props: {
              placeholder: "Enter Number of Units",
              type: "number",
            },
          },
          {
            label: "Units Metric",
            name: "tcProductUnitsMetric",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: !getTCStandardGOTS ? true : false,
            value: productData.tcProductUnitsMetric,
            props: {
              placeholder: "Enter Units Metric",
            },
          },
          {
            label: "Product Info Associated Tc", //label: 'Associated Product Info', renamed to match table header
            name: "tcProductInfoAssociatedTc",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            value: productData.tcProductInfoAssociatedTc,
            props: {
              placeholder: "Enter Associated Product Info",
            },
          },
          // {
          //   label: 'Product Certified Weight',
          //   name: 'tcProductCertifiedWeight',
          //   type: 'text',
          //   gridSize: { xs: 12, md: 4, lg: 4 },
          //   required: !getTCStandardGOTS ? true : false,
          //   props: {
          //     type: 'number',
          //     placeholder: 'Enter TC Product Certified Weight',
          //   },
          // },
          // {
          //   label: 'Product Standard (Label Grade)',
          //   name: 'tcProductStandardLabelGrade',
          //   type: 'select',
          //   gridSize: { xs: 12, md: 4, lg: 4 },
          //   required: !getTCStandardGOTS ? true : false,
          //   events: { onChange: onLabelGradeChange },
          //   // value: productData?.tcProductStandardInformation?.tcProductStandardLabelGrade,
          //   props: {
          //     options: labelGrades,
          //     placeholder: 'Select TC Product Standard (Label Grade)',
          //   },
          // },
        ],
      },
    ],
    handleSubmit: (values: any) => {
      Utills.cl("Form Submitted: Product Info", values);
      setProductData(values);
      toggleDrawer();
      // resetForm();
    },
  };

  return (
    <>
      {showWarning && (
        <Box
          sx={{
            p: 2,
            mb: 2,
            bgcolor: "#FFF3E0",
            borderRadius: 1,
            border: "1px solid #FFB74D",
          }}
        >
          <Typography color="warning.dark">
            Note: Any changes to the Certified Organization (CO) details should
            be made in the "Certified Organization Details" tab.
          </Typography>
        </Box>
      )}
      {/* <Box display="flex" mb={3} justifyContent="flex-end" width="100%">
        <StyledButton variant="contained" onClick={toggleDrawer}>Add Product</StyledButton>
      </Box>
      <Box display="grid">
      <CustomTable
        columns={columns}
        data={data}
        enableTopToolbar={false}
        enableBottomToolbar={true}
        enableRowActions={true}
        renderRowActions={({ row }) => (
          <ActionsMenu
            // onEdit={() => handleEdit(row)}
            // onDelete={() => handleDelete(row)}
            row={row}
          />
        )}
      />
      </Box> */}
      {/* <ModalPopup open={drawerOpen} onClose={toggleDrawer} onSave={handleSubmit}> */}
      <FormBuilder
        formConfig={formConfig}
        onSubmit={formConfig.handleSubmit}
        formRef={formRef}
      />
      {/* </ModalPopup> */}
    </>
  );
};

export default ProductInfo;
